<template>
  <b-card-code class="principal mt-2">
    <b-modal
      id="modal-lg"
      ref="modal-persona"
      ok-only
      ok-title="Aceptar"
      centered
      size="lg"
      title="Detalle persona"
      style="font-weight: bold"
    >
      <b-row v-if="this.field_persona">
        <b-col cols="4">
          <b-form-group
            label="Identificación:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_persona.cedula"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="RUC:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_persona.ruc ? this.field_persona.ruc : 'N/A'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Tipo:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="
                this.field_persona.tipoNatJur === 'N' ? 'Natural' : 'Jurídica'
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Tipo pasajero:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.procesarTipoPasajero(field_persona.tipoPasajero)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Nombre comercial:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="
                this.field_persona.nombreComercial
                  ? this.field_persona.nombreComercial
                  : 'N/A'
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Razón social:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="
                this.field_persona.razonSocial
                  ? this.field_persona.razonSocial
                  : 'N/A'
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Correo electrónico:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="
                this.field_persona.email ? this.field_persona.email : 'N/A'
              "
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Extranjero:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_persona.esExtranjero ? 'Sí' : 'No'"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="modal-lg"
      ref="modal-boleto"
      ok-only
      ok-title="Aceptar"
      centered
      size="lg"
      title="Detalle boleto"
      style="font-weight: bold"
    >
      <b-row v-if="this.field_boleto">
        <b-col cols="12">
          <b-form-group
            label="Código QR:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_boleto.codigoQr"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Número documento:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_boleto.numero_documento"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Secuencia:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_boleto.secuencia"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Tipo de boleto:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.procesarTipoBoleto(this.field_boleto.tipoBoleto)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Tipo de tarifa:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.procesarTipoTarifa(this.field_boleto.tipoTarifa)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label="Producto contífico:"
            label-for="plainTextInput"
            style="font-weight: bold"
          >
            <b-form-input
              id="plainTextInput"
              disabled
              plaintext
              :value="this.field_boleto.producto_contifico"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-row class="principal mt-2">
      <b-col md="12">
        <b-card-title class="font-medium-2" style="text-align: center">
          <span>Información del viaje</span>
        </b-card-title>
      </b-col>

      <b-col md="3">
        <b-form-group
          label="Código:"
          label-for="plainTextInput"
          style="font-weight: bold"
        >
          <b-form-input
            id="plainTextInput"
            disabled
            plaintext
            :value="codigo_viaje"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Estado:"
          label-for="plainTextInput"
          style="font-weight: bold"
        >
          <b-form-input
            id="plainTextInput"
            disabled
            plaintext
            :value="procesarTipoViaje(estado_viaje)"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Trayecto:"
          label-for="plainTextInput"
          style="font-weight: bold"
        >
          <b-form-input
            id="plainTextInput"
            disabled
            plaintext
            :value="trayecto"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Chófer:"
          label-for="plainTextInput"
          style="font-weight: bold"
        >
          <b-form-input
            id="plainTextInput"
            disabled
            plaintext
            :value="chofer"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Placa/Disco:"
          label-for="plainTextInput"
          style="font-weight: bold"
        >
          <b-form-input id="plainTextInput" disabled plaintext :value="bus" />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Número de marcaciones:"
          label-for="plainTextInput"
          style="font-weight: bold"
        >
          <b-form-input
            id="plainTextInput"
            disabled
            plaintext
            :value="capacidad_bus"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col v-if="items.length > 0" cols="12" class="pr-0 pl-0 mt-1">
        <b-card-title class="font-medium-2" style="text-align: center">
          <span>Tabla de marcaciones</span>
        </b-card-title>
        <b-table
          bordered
          striped
          responsive
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          class="mb-1"
        >
          <template #cell(persona)="data">
            <div>
              <a v-if="data.item.persona">
                <span v-b-tooltip.hover title="Persona">
                  <feather-icon icon="UserIcon" size="14" />
                </span>
                <b-link @click="abrirDetalleMarcacion(data.item)">
                  <!--                  <a v-if="data.item.persona.cedula">{{ data.item.persona.cedula }}</a>-->
                  <!--                  <a v-else>{{data.item.persona.ruc}}</a>-->
                  <a> {{ data.item.persona.razonSocial }} </a>
                </b-link>
              </a>
              <a v-else-if="data.item.boleto">
                <span v-b-tooltip.hover title="Boleto">
                  <svg-icon type="mdi" :path="path" size="14" />
                </span>
                <b-link @click="abrirDetalleMarcacion(data.item)">
                  <a>
                    {{ data.item.boleto.numero_documento }}
                    <span v-b-tooltip.hover title="Secuencia">
                      <b-badge variant="light-secondary">
                        {{ data.item.boleto.secuencia }}
                      </b-badge>
                    </span>
                    &nbsp;
                    <span v-b-tooltip.hover title="Marcación de tarjeta" v-if="data.item.boleto.tarjeta">
                      <b-badge variant="light-success">
                        <feather-icon icon="CreditCardIcon" size="14" /> {{ data.item.boleto.tarjeta.codigo }}
                      </b-badge>
                    </span>
                    <span v-b-tooltip.hover title="Marcación de boleto físico" v-else-if="data.item.boleto.detalleOrden === null">
                      <b-badge variant="light-info">
                        <feather-icon icon="FilmIcon" size="14" /> Físico
                      </b-badge>
                    </span>
                    <span v-b-tooltip.hover title="Marcación de boleto digital" v-else-if="data.item.boleto.detalleOrden.orden.paymentezId">
                      <b-badge variant="light-info">
                        <feather-icon icon="FilmIcon" size="14" /> Digital
                      </b-badge>
                    </span>
                    <span v-b-tooltip.hover title="Marcación de boleto POS" v-else-if="data.item.boleto.detalleOrden !== null">
                      <b-badge variant="light-warning">
                        <feather-icon icon="AirplayIcon" size="14" /> POS
                      </b-badge>
                    </span>
                  </a>
                </b-link>
              </a>
              <a v-else> - </a>
              <span
                v-if="
                  data.item.validacionCaducidad &&
                  data.item.marcacion_correcta === false
                "
                v-b-tooltip.hover
                :title="
                  data.item.validacionCaducidad.usuario.username +
                  ' ' +
                  new Date(
                    data.item.validacionCaducidad.fecha_hora_validacion
                  ).toLocaleString('pt-BR')
                "
                class="text-danger ml-1"
              >
                <feather-icon icon="XCircleIcon" size="16" />
              </span>
              <span
                v-if="
                  data.item.validacionCaducidad &&
                  data.item.marcacion_correcta === true
                "
                v-b-tooltip.hover
                :title="
                  data.item.validacionCaducidad.usuario.username +
                  ' ' +
                  new Date(
                    data.item.validacionCaducidad.fecha_hora_validacion
                  ).toLocaleString('pt-BR')
                "
                class="text-success ml-1"
              >
                <feather-icon icon="CheckCircleIcon" size="16" />
              </span>
              <b-button
                v-if="
                  permisos.indexOf('gest_bol_cadu_marcacion') !== -1 &&
                  data.item.caducado_pendiente_revisar
                "
                variant="primary"
                size="sm"
                class="ml-1"
                @click="validarBoleto(data.item.token)"
              >
                Validar
              </b-button>
            </div>
          </template>
          <template #cell(fechaMarcacion)="data">
            <span
              v-b-tooltip.hover
              title="Fecha de marcación"
              class="text-success"
              ><feather-icon icon="ClockIcon" size="14" />
            </span>
            <a style="font-size: 12px">{{
              new Date(data.value).toLocaleString("pt-BR")
            }}</a>
            <br />
            <span
              v-b-tooltip.hover
              title="Fecha de creación o subida"
              class="text-warning"
              ><feather-icon icon="ClockIcon" size="14" />
            </span>
            <a style="font-size: 12px">{{
              new Date(data.item.fechaCreacion).toLocaleString("pt-BR")
            }}</a>
          </template>
          <template #cell(tipoPasajero)="data">
            <div v-if="data.item.persona">
              {{ procesarTipoPasajero(data.item.persona.tipoPasajero) }}
            </div>
            <div v-else>N/A</div>
          </template>
          <template #cell(tipoBoleto)="data">
            <div v-if="data.item.boleto">
              {{ procesarTipoBoleto(data.item.boleto.tipoBoleto) }}
            </div>
            <div v-else>N/A</div>
          </template>
          <template #cell(tipoTarifa)="data">
            <div v-if="data.item.boleto">
              {{ procesarTipoTarifa(data.item.boleto.tipoTarifa) }}
            </div>
            <div v-else>N/A</div>
          </template>
        </b-table>
      </b-col>
      <!--      </b-card-code>-->
      <p v-else class="mt-1">No hay registros para mostrar</p>
    </b-row>
  </b-card-code>
</template>
<script>
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiTicket } from "@mdi/js";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BPagination,
  BTable,
  BLink,
  BCardHeader,
  BCardTitle,
  BTooltip,
  VBTooltip,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code";
import { required, integer } from "@validations";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import es from "vee-validate/dist/locale/es.json";
import actions from "@/assets/utils/utils.js";
import $ from "jquery";
import Vue from "vue";

localize({
  es,
});

localize("es");

export default {
  components: {
    BBadge,
    SvgIcon,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BTable,
    BPagination,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    vSelect,
    BLink,
    BCardHeader,
    BCardTitle,
    BTooltip,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      path: mdiTicket,
      login_user: "",

      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      fields: [
        {
          key: "persona",
          label: "Persona/Boleto",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "30%" },
        },
        {
          key: "fechaMarcacion",
          label: "Fecha marcación",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "15%" },
        },
        // {
        //   key: 'tipo_marcacion', label: 'Tipo de marcación', sortable: true, thClass: 'text-center', thStyle: { width: '10%' },
        // },
        {
          key: "tipoBoleto",
          label: "Tipo boleto",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "12%" },
        },
        {
          key: "tipoTarifa",
          label: "Tipo tarifa",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "13%" },
        },
        {
          key: "tipoPasajero",
          label: "Tipo pasajero",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "12%" },
        },
        {
          key: "observacion_marcacion",
          label: "Observación marcación",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "15%" },
        },
      ],
      items: [],

      required,
      integer,

      field_persona: "",
      field_boleto: "",

      tipo_boleto: "",
      tipo_tarifa: "",
      tipoPasajero: "",
      estados_viajes: [
        {
          value: "FIN",
          text: "Finalizado",
        },
        {
          value: "PEN",
          text: "Pendiente",
        },
        {
          value: "CUR",
          text: "En curso",
        },
        {
          value: "ANU",
          text: "Anulado",
        },
      ],

      codigo_viaje: "",
      estado_viaje: "",
      fecha_inicio: "",
      fecha_fin: "",
      trayecto: "",
      chofer: "",
      bus: "",
      capacidad_bus: "",

      marcacionCorrecta: "",
      permisos: "",
    };
  },
  mounted() {
    if (this.$route.params.token) {
      this.token = this.$route.params.token;
      this.cargarTipoPasajero();
      this.getMarcacion();
    } else {
      console.log("NO ENTRO");
    }
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  methods: {
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("viaje_viaje_marcacion") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      } else {
        this.permisos = localStorage.getItem("permisos");
      }
    },
    procesarTipoViaje(texto) {
      for (const estado_viaje of this.estados_viajes) {
        if (texto === estado_viaje.value) {
          return estado_viaje.text;
        }
      }
    },
    procesarTipoBoleto(texto) {
      for (const pasajero of this.tipo_boleto) {
        if (texto === pasajero.value) {
          return pasajero.text;
        }
      }
    },
    procesarTipoTarifa(texto) {
      for (const persona of this.tipo_tarifa) {
        if (texto === persona.value) {
          return persona.text;
        }
      }
    },
    procesarTipoPasajero(texto) {
      for (const persona of this.tipoPasajero) {
        if (texto === persona.value) {
          return persona.text;
        }
      }
    },
    validarBoleto(token_marcacion) {
      this.$swal({
        title: "Validación de Boleto Caducado",
        text: "¿Desea aceptar o rechazar este boleto?",
        icon: "warning",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Aceptar",
        denyButtonText: "Rechazar",

        customClass: {
          confirmButton: "btn btn-primary",
          denyButton: "btn btn-danger ml-1",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        this.marcacionCorrecta = result.value;
        if (result.value === true) {
          this.$swal({
            icon: "success",
            title: "Validación boleto caducado",
            text: "El boleto ha sido aceptado con éxito.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (result.value === false) {
          this.$swal({
            icon: "success",
            title: "Validación boleto caducado",
            text: "El boleto ha sido rechazado con éxito.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
        if (
          this.marcacionCorrecta === false ||
          this.marcacionCorrecta === true
        ) {
          axios
            .post("api", {
              query: `mutation validacionCaducidadBoleto($tokenMarcacion: String!, $marcacionCorrecta: Boolean!){
                validacionCaducidadBoleto(tokenMarcacion:$tokenMarcacion, marcacionCorrecta: $marcacionCorrecta)
                {
                    status,
                    message,
                }
            }`,
              variables: {
                tokenMarcacion: token_marcacion,
                marcacionCorrecta: this.marcacionCorrecta,
              },
            })
            .then((response) => {
              if (response.status === 200) {
                if (
                  response.data.data.validacionCaducidadBoleto.status ===
                  "success"
                ) {
                  this.getMarcacion();
                }
              }
            });
        }
      });
    },
    cargarTipoPasajero() {
      axios
        .post("api", {
          query: `{
                    getTipoPasajero{
                        lista{
                            text,
                            value,
                        },
                        status,
                        message
                    }
                }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getTipoPasajero.status === "success") {
              this.tipoPasajero = response.data.data.getTipoPasajero.lista;
            }
          }
        });
    },
    getMarcacion() {
      axios
        .post("api", {
          query: `query getMarcaciones($token: String!){
                    getMarcaciones(tokenViaje:$token){
                        viaje{
                            num_pasajeros_marcado: numPasajerosMarcado,
                            codigo,
                            bus{
                                placa,
                                disco,
                                cantidad_pasajeros: cantidadPasajeros
                            },
                            chofer{
                                username
                            },
                            estado,
                            trayecto{
                                origen{
                                    nombre
                                },
                                destino{
                                    nombre
                                }
                            },
                            fecha_inicio: fechaInicio,
                            fecha_fin: fechaFin
                        },
                        marcaciones{
                            token,
                            fechaCreacion,
                            fechaMarcacion,
                            persona{
                                token,
                                cedula,
                                ruc,
                                nombres,
                                apellidos,
                                tipoNatJur,
                                tipoPasajero,
                                nombreComercial,
                                razonSocial,
                                email,
                                esExtranjero,
                            },
                            boleto{
                                token,
                                codigoQr,
                                numero_documento: numeroDocumento,
                                producto_contifico: productoContifico,
                                boletoshort,
                                secuencia,
                                fechaCaducidad,
                                tipoBoleto,
                                tipoTarifa
                                tarjeta{
                                  codigo
                                }
                                detalleOrden{
                                  orden{
                                    paymentezId
                                  }
                                }
                            },
                            observacion_marcacion: observacionMarcacion,
                            caducado_pendiente_revisar: caducadoPendienteRevisar,
                            caducado_validado: caducadoValidado,
                            marcacion_correcta: marcacionCorrecta,
                            validacionCaducidad{
                                fecha_hora_validacion: fechaHoraValidacion,
                                usuario{
                                    username,
                                },
                            }
                        },
                        listaTipoBoleto{
                            value,
                            text,
                        },
                        listaTipoTarifa{
                            value,
                            text,
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            token: this.$route.params.token,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getMarcaciones.status === "success") {
              this.items = response.data.data.getMarcaciones.marcaciones;
              this.tipo_boleto =
                response.data.data.getMarcaciones.listaTipoBoleto;
              this.tipo_tarifa =
                response.data.data.getMarcaciones.listaTipoTarifa;
              this.codigo_viaje =
                response.data.data.getMarcaciones.viaje.codigo;
              this.estado_viaje =
                response.data.data.getMarcaciones.viaje.estado;
              if (
                isNaN(response.data.data.getMarcaciones.viaje.fecha_inicio) ===
                true
              ) {
                this.fecha_inicio = new Date(
                  response.data.data.getMarcaciones.viaje.fecha_inicio
                ).toLocaleString("pt-BR");
              } else {
                this.fecha_inicio = "N/A";
              }
              if (
                isNaN(response.data.data.getMarcaciones.viaje.fecha_fin) ===
                true
              ) {
                this.fecha_fin = new Date(
                  response.data.data.getMarcaciones.viaje.fecha_fin
                ).toLocaleString("pt-BR");
              } else {
                this.fecha_fin = "N/A";
              }
              this.trayecto = `${response.data.data.getMarcaciones.viaje.trayecto.origen.nombre} - ${response.data.data.getMarcaciones.viaje.trayecto.destino.nombre}`;
              this.chofer =
                response.data.data.getMarcaciones.viaje.chofer.username;
              this.bus = `${response.data.data.getMarcaciones.viaje.bus.placa} / ${response.data.data.getMarcaciones.viaje.bus.disco}`;
              this.capacidad_bus =
                response.data.data.getMarcaciones.viaje.num_pasajeros_marcado;
            } else {
              this.$router.push({ name: "error-404" });
            }
          }
        });
    },
    abrirDetalleMarcacion(item, index, event) {
      if (item.persona) {
        this.field_persona = item.persona;
        this.showModal("modal-persona");
      } else {
        this.field_boleto = item.boleto;
        this.showModal("modal-boleto");
      }
    },
    showModal(name) {
      this.$refs[name].show();
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
</style>
